import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description MedicalCross icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { MedicalCross } from '@sravni/design-system-icons'
 *
 * <MedicalCross />
 * ```
 */
var MedicalCross = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "MedicalCross", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "m16.362 12 3.577 2.018a1 1 0 0 1 .37 1.38l-1.163 1.969a.999.999 0 0 1-1.352.362l-3.612-2.038V20a1 1 0 0 1-1 1H10.82a1 1 0 0 1-1-1v-4.309l-3.612 2.038a.999.999 0 0 1-1.352-.362l-1.163-1.969a1 1 0 0 1 .37-1.38L7.638 12 4.061 9.982a1 1 0 0 1-.37-1.38l1.163-1.969a.999.999 0 0 1 1.352-.362l3.612 2.038V4a1 1 0 0 1 1-1h2.362a1 1 0 0 1 1 1v4.309l3.612-2.038a.999.999 0 0 1 1.352.362l1.163 1.969a1 1 0 0 1-.37 1.38L16.362 12Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { MedicalCross };
//# sourceMappingURL=MedicalCross.js.map
